module.exports = __webpack_public_path__ + "c6ce0010471b65c0faeda6c53ab297bd.svg";